/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'
import * as constants from './constants'
import { default as rootReducer } from './reducers/index'

// eslint-disable-next-line import/no-default-export
export default filterActions(rootReducer, Object.values(constants))
